const details = document.getElementById("header-search");
document.addEventListener("click", function (event) {
  if ( details && details.hasAttribute("open") && !details.contains(event.target)) {
    // Add closing class → trigger fadeout
    details.classList.add("closing");

    // Wait for animation, then fully close
    setTimeout(() => {
      details.removeAttribute("open");
      details.classList.remove("closing");
    }, 250); // same as animation duration
  }
});
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);


document.addEventListener("DOMContentLoaded", function () {
  const closeBtn = document.querySelector(".search-close-btn");
  const details = document.querySelector(".header__search details");

  if (closeBtn && details) {
    closeBtn.addEventListener("click", function () {
      details.removeAttribute("open");
    });
  }
});

document.addEventListener("keydown", function(e) {
  if (e.key === "Escape") {
    const details = document.querySelector(".header__search details");
    if (details && details.hasAttribute("open")) {
      details.removeAttribute("open");
    }
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const details = document.querySelector(".header__search details");
  const closeBtn = document.querySelector(".search-close-btn");

  if (!details) return;

  // When search opens
  details.addEventListener("toggle", function () {
    if (details.open) {
      document.body.classList.add("search-open");
    } else {
      document.body.classList.remove("search-open");
    }
  });

  // Close button click
  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      details.removeAttribute("open");
    });
  }
});


document.addEventListener("DOMContentLoaded", function () {
  const input = document.querySelector(".header__search input[type='search']");
  const form = document.querySelector(".header__search form");

  if (!input || !form) return;

  // Prevent first space
  input.addEventListener("keydown", function (e) {
    if (e.key === " " && !this.value.trim().length) {
      e.preventDefault();
    }
  });

  // Prevent empty search submit
  form.addEventListener("submit", function (e) {
    const value = input.value.trim();

    if (!value.length) {
      e.preventDefault();
      input.value = "";
    }
  });
});